import axios, { AxiosError } from "axios"
import {
  requestInterceptorSuccessCredentials,
  requestInterceptorErrorSecurityCredentials,
  responseInterceptorSuccessCredentials,
  responseInterceptorErrorCredentials,
} from "interceptors"
import {
  ISSUED_PATH,
  REJECTED_PATH,
  REPORT_PATH,
  SEND_BY_EMAIL_PATH,
  SEND_REJECT_REPORT_EMAIL_PATH,
} from "lib"
const instance = axios.create({
  baseURL: process.env.REACT_APP_DOCUMENTS_API_SERVICE_DOMAIN,
})
instance.interceptors.request.use(
  requestInterceptorSuccessCredentials,
  requestInterceptorErrorSecurityCredentials
)

instance.interceptors.response.use(
  responseInterceptorSuccessCredentials,
  responseInterceptorErrorCredentials
)

export const sendDocumentReportByEmailService = async (params: any) => {
  try {
    const result = await instance.post(REPORT_PATH + SEND_BY_EMAIL_PATH, params)
    return result.data
  } catch (error: any) {
    const e: AxiosError = error
    throw new Error(e.response?.data)
  }
}

export const sendRejectedReportByEmailService = async (params: any) => {
  try {
    const result = await instance.post(
      REJECTED_PATH + SEND_REJECT_REPORT_EMAIL_PATH,
      params
    )
    return result.data
  } catch (error: any) {
    const e: AxiosError = error
    throw new Error(e.response?.data)
  }
}

export const sendRetentionReportByEmailService = async (params: any) => {
  try {
    const result = await instance.post(REPORT_PATH + ISSUED_PATH, params)
    return result.data
  } catch (error: any) {
    const e: AxiosError = error
    throw new Error(e.response?.data)
  }
}
